/* ============================================================
   Minimal, dependency-free SVG icon set for the sidebar.
   Stroke-based so they inherit color from `currentColor`.
   ============================================================ */

function Svg({ children, size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export function IconDashboard(p) {
  return (
    <Svg {...p}>
      <rect x="3" y="3"  width="8" height="8" rx="1.5" />
      <rect x="13" y="3" width="8" height="5" rx="1.5" />
      <rect x="13" y="10" width="8" height="11" rx="1.5" />
      <rect x="3" y="13" width="8" height="8" rx="1.5" />
    </Svg>
  );
}

export function IconLeads(p) {
  /* lightning bolt */
  return (
    <Svg {...p}>
      <path d="M13 3 L5 13 H11 L9 21 L19 10 H13 L15 3 Z" />
    </Svg>
  );
}

export function IconDeals(p) {
  /* circled dollar */
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="9" />
      <path d="M15 9.5C14.4 8.5 13.3 8 12 8c-1.7 0-3 1-3 2.3 0 1.2 1 1.7 3 2.2 2 .5 3 1 3 2.2 0 1.4-1.3 2.3-3 2.3-1.5 0-2.7-.6-3.3-1.5" />
      <path d="M12 6.5v11" />
    </Svg>
  );
}

export function IconCustomers(p) {
  /* people group */
  return (
    <Svg {...p}>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M2.5 20c0-3 3-5 6.5-5s6.5 2 6.5 5" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M14.5 14.5c2.8 0 6.5 1.5 6.5 4.5" />
    </Svg>
  );
}

export function IconDeadLeads(p) {
  /* refresh/revive arrows */
  return (
    <Svg {...p}>
      <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
      <path d="M21 3v5h-5" />
      <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
      <path d="M3 21v-5h5" />
    </Svg>
  );
}

export function IconService(p) {
  /* headset */
  return (
    <Svg {...p}>
      <path d="M4 13v-2a8 8 0 0 1 16 0v2" />
      <rect x="3" y="13" width="4" height="6" rx="1.5" />
      <rect x="17" y="13" width="4" height="6" rx="1.5" />
      <path d="M20 18.5v.5a3 3 0 0 1-3 3h-3" />
    </Svg>
  );
}

export function IconTriage(p) {
  /* flag */
  return (
    <Svg {...p}>
      <path d="M5 21V4" />
      <path d="M5 4h12l-2 4 2 4H5" />
    </Svg>
  );
}

export function IconCompliance(p) {
  /* shield + check */
  return (
    <Svg {...p}>
      <path d="M12 3 L4 6v6c0 4.5 3.4 8.4 8 9 4.6-.6 8-4.5 8-9V6L12 3z" />
      <path d="M9 12l2.2 2.2L15 10.5" />
    </Svg>
  );
}

export function IconInventory(p) {
  /* car (side view) */
  return (
    <Svg {...p}>
      <path d="M5 16h14" />
      <path d="M3 16l1.5-5a3 3 0 0 1 3-2h9a3 3 0 0 1 3 2L21 16" />
      <path d="M3 16v3h2" />
      <path d="M21 16v3h-2" />
      <circle cx="7" cy="17" r="1.5" />
      <circle cx="17" cy="17" r="1.5" />
    </Svg>
  );
}

export function IconSettings(p) {
  /* gear */
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
    </Svg>
  );
}

export function IconHelp(p) {
  /* life-ring — friendlier than a question mark, and reads at 16px */
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="3.5" />
      <path d="M5.6 5.6l3.9 3.9M14.5 14.5l3.9 3.9M18.4 5.6l-3.9 3.9M9.5 14.5l-3.9 3.9" />
    </Svg>
  );
}

export function IconChannels(p) {
  /* signal / activity waves — reads as "live traffic" at 16px */
  return (
    <Svg {...p}>
      <path d="M3 12h3l2.5-7 3 14 2.5-7h3" />
      <circle cx="20.5" cy="12" r="1.2" />
    </Svg>
  );
}

export function IconAppointments(p) {
  /* calendar with a check */
  return (
    <Svg {...p}>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 9h18" />
      <path d="M8 3v4M16 3v4" />
      <path d="M9.5 14.5l2 2 3.5-3.5" />
    </Svg>
  );
}

export function IconTeam(p) {
  /* two people */
  return (
    <Svg {...p}>
      <circle cx="9" cy="8" r="3" />
      <path d="M3.5 20a5.5 5.5 0 0 1 11 0" />
      <path d="M16 6.5a3 3 0 0 1 0 5.5" />
      <path d="M17 14.2a5.5 5.5 0 0 1 3.5 5.1" />
    </Svg>
  );
}

export function IconDiary(p) {
  /* calendar with a clock — working hours */
  return (
    <Svg {...p}>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 9h18" />
      <path d="M8 3v4M16 3v4" />
      <circle cx="12" cy="15" r="3.2" />
      <path d="M12 13.6v1.6l1 .8" />
    </Svg>
  );
}

export function IconTasks(p) {
  /* checklist */
  return (
    <Svg {...p}>
      <path d="M4 6l1.5 1.5L8 5" />
      <path d="M11 6.5h10" />
      <path d="M4 12l1.5 1.5L8 11" />
      <path d="M11 12.5h10" />
      <path d="M4 18l1.5 1.5L8 17" />
      <path d="M11 18.5h10" />
    </Svg>
  );
}

export function IconPipeline(p) {
  /* funnel */
  return (
    <Svg {...p}>
      <path d="M3 4h18l-7 8v6l-4 3v-9L3 4z" />
    </Svg>
  );
}

export function IconTestDrives(p) {
  /* steering wheel */
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="2.5" />
      <path d="M3.3 10.5C6 9.2 9 8.5 12 8.5s6 .7 8.7 2" />
      <path d="M12 14.5V21" />
    </Svg>
  );
}

export function IconLoanCars(p) {
  /* key */
  return (
    <Svg {...p}>
      <circle cx="8" cy="15" r="4.5" />
      <path d="M11.2 11.8L20 3" />
      <path d="M16.5 6.5l3 3" />
      <path d="M14 9l2 2" />
    </Svg>
  );
}

export function IconAppraisals(p) {
  /* price tag */
  return (
    <Svg {...p}>
      <path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9-9-9z" />
      <circle cx="8" cy="8" r="1.6" />
    </Svg>
  );
}

export function IconCampaigns(p) {
  /* megaphone */
  return (
    <Svg {...p}>
      <path d="M3 11v3a1.5 1.5 0 0 0 1.5 1.5H7l11 5V4L7 9H4.5A1.5 1.5 0 0 0 3 10.5z" />
      <path d="M18 9a3 3 0 0 1 0 6" />
      <path d="M8 15.5l1.2 5H12l-1.3-5" />
    </Svg>
  );
}

export function IconSurveys(p) {
  /* chat bubble with poll lines */
  return (
    <Svg {...p}>
      <path d="M21 12a8 8 0 0 1-8 8H4l2-3.2A8 8 0 1 1 21 12z" />
      <path d="M8 10h8M8 13.5h5" />
    </Svg>
  );
}

export function IconAnalytics(p) {
  /* bar chart */
  return (
    <Svg {...p}>
      <path d="M3 21h18" />
      <path d="M6.5 21v-7" />
      <path d="M11.5 21V9" />
      <path d="M16.5 21V4" />
    </Svg>
  );
}

export function IconKpis(p) {
  /* target */
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1.4" />
    </Svg>
  );
}

export function IconOnboarding(p) {
  /* rocket */
  return (
    <Svg {...p}>
      <path d="M12 15c-1.5-4.5 0-9 4.5-12 1.5 0 3 0 4.5 1.5 0 4.5-3 8-7.5 10.5" />
      <path d="M12 15l-3-3" />
      <path d="M9 12c-2 0-3.5 1-4.5 3 1.5.5 2.5.5 3.5 0" />
      <path d="M12 15c0 2-1 3.5-3 4.5-.5-1.5-.5-2.5 0-3.5" />
      <circle cx="15.5" cy="8.5" r="1.4" />
    </Svg>
  );
}

export function IconBilling(p) {
  /* credit card */
  return (
    <Svg {...p}>
      <rect x="2.5" y="5" width="19" height="14" rx="2" />
      <path d="M2.5 10h19" />
      <path d="M6 15h5" />
    </Svg>
  );
}

export function IconHealth(p) {
  /* heart with pulse */
  return (
    <Svg {...p}>
      <path d="M12 20.5S3.5 15 3.5 9.2A4.7 4.7 0 0 1 12 6.4a4.7 4.7 0 0 1 8.5 2.8c0 5.8-8.5 11.3-8.5 11.3z" />
      <path d="M6.5 11.5h3l1.5-2.5 2 4 1.5-2.5h3" />
    </Svg>
  );
}

export function IconQuotes(p) {
  /* document with a price tag */
  return (
    <Svg {...p}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <path d="M14 3v5h5" />
      <path d="M8.5 13h4" />
      <path d="M8.5 16.5h6" />
    </Svg>
  );
}

/* Map by nav key for convenient lookup. */
export const NAV_ICONS = {
  home:         IconDashboard,
  quotes:       IconQuotes,
  leads:        IconLeads,
  deals:        IconDeals,
  customers:    IconCustomers,
  dead:         IconDeadLeads,
  inventory:    IconInventory,
  service:      IconService,
  triage:       IconTriage,
  compliance:   IconCompliance,
  channels:     IconChannels,
  settings:     IconSettings,
  help:         IconHelp,
  appointments: IconAppointments,
  diary:        IconDiary,
  team:         IconTeam,
  tasks:        IconTasks,
  pipeline:     IconPipeline,
  testdrives:   IconTestDrives,
  loancars:     IconLoanCars,
  appraisals:   IconAppraisals,
  campaigns:    IconCampaigns,
  surveys:      IconSurveys,
  analytics:    IconAnalytics,
  kpis:         IconKpis,
  onboarding:   IconOnboarding,
  billing:      IconBilling,
  health:       IconHealth,
};
